import { render } from "./QuickCard.vue?vue&type=template&id=0ed8be56&scoped=true"
import script from "./QuickCard.vue?vue&type=script&lang=js"
export * from "./QuickCard.vue?vue&type=script&lang=js"

import "./QuickCard.vue?vue&type=style&index=0&id=0ed8be56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed8be56"]])

export default __exports__